import { useContext } from "react";
import { StationThemeContext } from "./Context";
export { StationThemeProvider } from "./Provider";

export function useStationTheme() {
  return useContext(StationThemeContext);
}
